import { ENotificationFrequency } from "./enum/notification-frequency"

export class Notification {
    IsActive!: boolean;
    HasAccuseReceptionDossier!: boolean;
    FrequenceAccuseReceptionDossier!: ENotificationFrequency;
    HasNCReception!: boolean;
    FrequenceNCReception!: ENotificationFrequency;
    HasNCMesure!: boolean;
    FrequenceNCMesure!: ENotificationFrequency;
    HasOnlyNCMesureBloquant!: boolean;
    HasRetard!: boolean;
    FrequenceRetard!: ENotificationFrequency;
    HasAccuseEnvoiRapport!: boolean;
    FrequenceAccuseEnvoiRapport!: ENotificationFrequency;
    HasOnlyDossierAmiante!: boolean;
    Phone?: string;

    static mapFromJSON(json: any) {

        let n = new Notification();
        
        n.Phone = json['phone'];
        n.IsActive = json['isActive'];
        n.HasAccuseReceptionDossier = json['hasAccuseReceptionDossier'];
        n.FrequenceAccuseReceptionDossier = json['frequenceAccuseReceptionDossier'];
        n.HasNCReception = json['hasNCReception'];
        n.FrequenceNCReception = json['frequenceNCReception'];
        n.HasNCMesure = json['hasNCMesure'];
        n.FrequenceNCMesure = json['frequenceNCMesure'];
        n.HasOnlyNCMesureBloquant = json['hasOnlyNCMesureBloquant'];
        n.HasRetard = json['hasRetard'];
        n.FrequenceRetard = json['frequenceRetard'];
        n.HasAccuseEnvoiRapport = json['hasAccuseEnvoiRapport'];
        n.FrequenceAccuseEnvoiRapport = json['frequenceAccuseEnvoiRapport'];
        n.HasOnlyDossierAmiante = json['hasOnlyDossierAmiante'];

        return n;
    }
}